import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as Chart from 'chart.js';
import { BusinessCommonService } from 'src/app/business-common/service/business-common.service';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';

@Component({
  selector: 'sym-sales-metrics-dashboard',
  templateUrl: './sales-metrics-dashboard.component.html',
  styleUrls: ['./sales-metrics-dashboard.component.scss'],
})
export class SalesMetricsDashboardComponent extends BaseComponent<BusinessCommonService> implements OnInit {
  public dashboarddata: any;
  public isMobileViewRendered: boolean;
  constructor(
    public service: BusinessCommonService,
    public router: Router,
    public headerService: HeaderService,
    public settingService: SettingService,
    public http: HttpClient
  ) {
    super(service);
    //    this.isMobileViewRendered = this.service.isMobileViewRendered() && !this.service.isLandScapeViewRendered();
  }
  async ngOnInit() {
    this.dashboarddata = this.service.getDashboardData().salesMetricDashboard;
  }
  ngAfterViewInit(): void {
    this.dashboarddata = this.service.getDashboardData().salesMetricDashboard;
    this.initializeDonutCharts();
    this.initializeWinEachMonthChart();
    this.renderBarChart(
      'topPerformingAgentsChart',
      this.dashboarddata.topPerformingAgents,
      'Top Performing Agents'
    );

    this.renderBarChart(
      'topNonPerformingAgentsChart',
      this.dashboarddata.topNonPerformingAgents,
      'Top Non-Performing Agents'
    );
  }

  initializeWinEachMonthChart(): void {
    const ctx = (document.getElementById('winEachMonthChart') as HTMLCanvasElement).getContext('2d');

    if (ctx) {
      const threshold = 24; // Define the threshold value
      const data = this.dashboarddata.winEachMonth.data.map((item) => item.wins);

      // Create two datasets: One for above threshold, one for below threshold
      const aboveThresholdData = data.map((value) => (value >= threshold ? value : null));
      const belowThresholdData = data.map((value) => (value < threshold ? value : null));

      new Chart(ctx, {
        type: 'bar',
        data: {
          labels: this.dashboarddata.winEachMonth.data.map((item) => item.month),
          datasets: [
            {
              label: 'Above Threshold',
              data: aboveThresholdData,
              backgroundColor: 'rgba(75, 192, 192, 0.6)', // Green
              borderColor: 'rgba(75, 192, 192, 1)',
              borderWidth: 0,
              categoryPercentage: 1,
              barPercentage: 1,
            },
            {
              label: 'Below Threshold',
              data: belowThresholdData,
              backgroundColor: 'rgba(255, 99, 132, 0.6)', // Red
              borderColor: 'rgba(255, 99, 132, 1)',
              borderWidth: 0,
              categoryPercentage: 1,
              barPercentage: 1,
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              display: true,
            },
          },
          scales: {
            xAxes: [
              {
                stacked: true,
                scaleLabel: {
                  display: true,
                  labelString: 'Months',
                },
                gridLines: {
                  display: true,
                  drawTicks: true,
                  drawOnChartArea: false,
                },
              },
            ],
            yAxes: [
              {
                stacked: true,
                scaleLabel: {
                  display: true,
                  labelString: 'No. of Wins',
                },
                gridLines: {
                  display: true,
                  drawTicks: true,
                  drawOnChartArea: false,
                },
              },
            ],
          },
        },
        plugins: [
          {
            beforeDraw: (chart) => {
              const ctx = chart.ctx;
              const chartArea = chart.chartArea;
              const yScale = chart['scales']['y-axis-0'];
              const yValue = yScale.getPixelForValue(threshold); // Get the pixel position of the threshold value

              // Draw the threshold line
              ctx.save();
              ctx.beginPath();
              ctx.setLineDash([5, 5]); // Dotted line pattern
              ctx.strokeStyle = 'rgba(255, 205, 86, 1)'; // Line color (yellow)
              ctx.lineWidth = 2;
              ctx.moveTo(chartArea.left, yValue);
              ctx.lineTo(chartArea.right, yValue);
              ctx.stroke();
              ctx.restore();
            },
          },
        ],
      });
    }
  }

  initializeDonutCharts(): void {
    const donut1Ctx = (document.getElementById('donutChart1') as HTMLCanvasElement).getContext('2d');
    const donut2Ctx = (document.getElementById('donutChart2') as HTMLCanvasElement).getContext('2d');
    const donut1TotalPerc = this.dashboarddata?.conversionRatios?.opportunityToWinRatio?.donutPie1.leadToEapp;
    const donut2TotalPerc = this.dashboarddata?.conversionRatios?.opportunityToWinRatio?.donutPie2.oppToWin;
    if (donut1Ctx) {
      new Chart(donut1Ctx, {
        type: 'doughnut',
        data: {
          labels: ['Leads', 'E-App'],
          datasets: [
            {
              data: [
                this.dashboarddata?.conversionRatios.opportunityToWinRatio.donutPie1.leadToEapp,
                this.dashboarddata?.conversionRatios.opportunityToWinRatio.donutPie1.eAppToOpp,
              ],
              backgroundColor: ['rgb(86, 58, 58)', '#FF6384'],
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: 'bottom',
              onClick: function (event) {
                // Disable the legend click functionality
                event.stopPropagation();
              },
            },
          },
        },
        plugins: [
          {
            beforeDraw(chart) {
              const ctx = chart.ctx;
              const percentage = donut1TotalPerc; // E-App percentage, adjust if needed
              const chartArea = chart.chartArea;
              const centerX = (chartArea.left + chartArea.right) / 2;
              const centerY = (chartArea.top + chartArea.bottom) / 2;

              // Set styles for the percentage text
              ctx.font = 'bold 30px Arial'; // Adjust font size and style
              ctx.fillStyle = 'rgba(43, 34, 34, 0.5)'; // Set the text color
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';

              // Draw the percentage in the center of the donut chart
              ctx.fillText(percentage + '%', centerX, centerY);
            },
          },
        ],
      });
    }

    if (donut2Ctx) {
      new Chart(donut2Ctx, {
        type: 'doughnut',
        data: {
          labels: ['E-App', 'Policy'],
          datasets: [
            {
              data: [
                this.dashboarddata.conversionRatios.opportunityToWinRatio.donutPie2.eappToPolicy,
                this.dashboarddata.conversionRatios.opportunityToWinRatio.donutPie2.oppToWin,
              ],
              backgroundColor: ['#36A2EB', 'rgb(86, 58, 58)'],
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: 'bottom',
            },
          },
        },
        plugins: [
          {
            beforeDraw(chart) {
              const ctx = chart.ctx;
              const percentage = donut2TotalPerc; // E-App percentage, adjust if needed
              const chartArea = chart.chartArea;
              const centerX = (chartArea.left + chartArea.right) / 2;
              const centerY = (chartArea.top + chartArea.bottom) / 2;

              const chartWidth = chartArea.right - chartArea.left;
              const chartHeight = chartArea.bottom - chartArea.top;
              const minDimension = Math.min(chartWidth, chartHeight);
              const fontSize = Math.max(12, Math.floor(minDimension * 0.1));
              // Set styles for the percentage text
              ctx.font = 'bold ' + fontSize + 'px Arial'; // Adjust font size and style
              ctx.fillStyle = 'rgba(43, 34, 34, 0.5)'; // Set the text color
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';

              // Draw the percentage in the center of the donut chart
              ctx.fillText(percentage + '%', centerX, centerY);
            },
          },
        ],
      });
    }
  }

  renderBarChart(chartId: string, agents: any[], label: string): void {
    let barColors = ['rgba(220, 120, 120, 0.6)', 'rgba(140, 20, 20, 0.6)', 'rgba(14, 130, 21, 0.6)'];
    const ctx = document.getElementById(chartId) as HTMLCanvasElement;

    new Chart(ctx, {
      type: 'horizontalBar',
      data: {
        labels: agents.map((agent) => agent.name),
        datasets: [
          {
            label: 'Number of Wins',
            data: agents.map((agent) => agent.numberOfWins),
            backgroundColor: barColors.map((color) => color),
            borderColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 1,
            barThickness: this.isMobileViewRendered ? 15 : 40,
          },
          // {
          //   label: 'Average Days for Conversion',
          //   data: agents.map((agent) => agent.averageConversionDays),
          //   backgroundColor: 'rgba(255, 99, 132, 0.6)',
          //   borderColor: 'rgba(255, 99, 132, 1)',
          //   borderWidth: 1,
          //   barThickness: 15,
          // },
        ],
      },
      options: {
        responsive: true,
        legend: {
          display: false,
          position: 'top',
        },
        scales: {
          xAxes: [
            {
              stacked: true,
              scaleLabel: {
                display: true,
                labelString: 'Number of Wins',
              },
              gridLines: {
                display: true,
                drawTicks: true,
                drawOnChartArea: true,
              },
            },
          ],
          yAxes: [
            {
              stacked: true,
              scaleLabel: {
                display: true,
                labelString: 'Agents',
              },
              gridLines: {
                display: true,
                drawTicks: true,
                drawOnChartArea: false,
              },
            },
          ],
        },
      },
    });
  }
}
